"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirect = exports.isParent = exports.isElementVisible = exports.isBrowser = exports.hasParentClass = exports.hasParentAttribute = exports.hasClass = exports.getClass = exports.getAttributeValueFromParent = void 0;
var _console = require("../console");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var getClass = exports.getClass = function getClass(element) {
  return element.getAttribute && element.getAttribute('class') || '';
};
var hasClass = exports.hasClass = function hasClass(element, selector) {
  var rclass = /[\t\r\n\f]/g;
  var className = " ".concat(selector, " ");
  return element.nodeType === 1 && " ".concat(getClass(element), " ").replace(rclass, ' ').indexOf(className) > -1;
};
var hasParentClass = exports.hasParentClass = function hasParentClass(target, parentClass) {
  var t = target;
  while (t) {
    if (hasClass(t, parentClass)) {
      return true;
    }
    t = t.parentNode;
  }
  return false;
};
var isParent = exports.isParent = function isParent(child, parent) {
  var t = child.parentNode;
  while (t) {
    if (t === parent) {
      return true;
    }
    t = t.parentNode;
  }
  return false;
};
var getAttributeValueFromParent = exports.getAttributeValueFromParent = function getAttributeValueFromParent(target, parentAttributeName) {
  var t = target;
  while (t) {
    if (typeof t.hasAttribute === 'function' && t.hasAttribute(parentAttributeName)) {
      return typeof t.getAttribute === 'function' ? t.getAttribute(parentAttributeName) : null;
    }
    t = t.parentNode;
  }
  return null;
};
var hasParentAttribute = exports.hasParentAttribute = function hasParentAttribute(target, parentAttributeName) {
  return getAttributeValueFromParent(target, parentAttributeName) !== null;
};
var isBrowser = exports.isBrowser = function isBrowser() {
  return (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document !== null;
};
var redirect = exports.redirect = function redirect(url) {
  if (isBrowser()) {
    if (url === window.location.href) {
      window.location.reload(true);
    } else {
      window.location = url;
    }
  } else {
    (0, _console.consoleWarn)('Attempt to make redirect in not browser environment.');
  }
};
var isOutOfBorders = function isOutOfBorders(element, checkTop, topBorder, bottomBorder) {
  var _element$getBoundingC = element.getBoundingClientRect(),
    top = _element$getBoundingC.top,
    bottom = _element$getBoundingC.bottom;
  return (checkTop ? top : bottom) < topBorder || top > bottomBorder;
};
var isElement = function isElement(element) {
  return element != null && _typeof(element) === 'object' && element.nodeType === 1;
};
var isScrollable = function isScrollable(element) {
  if (element.clientHeight < element.scrollHeight) {
    var overflow = getComputedStyle(element).overflowY;
    return overflow !== 'visible' && overflow !== 'clip' && overflow !== 'hidden';
  }
  return false;
};
var isElementVisible = exports.isElementVisible = function isElementVisible(element) {
  var checkTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var topElement = document.documentElement;
  var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
  if (isOutOfBorders(element, checkTop, 0, viewportHeight)) {
    return false;
  }
  var container = element;
  while (container !== topElement && isElement(container)) {
    if (isScrollable(container)) {
      var _container$getBoundin = container.getBoundingClientRect(),
        top = _container$getBoundin.top,
        bottom = _container$getBoundin.bottom;
      if (isOutOfBorders(element, checkTop, top, bottom)) {
        return false;
      }
    }
    container = container.parentNode;
  }
  return true;
};